/* This file is for custom javascript of Singing Machine theme */

jQuery(document).ready(function() {

// BEGIN of script for slider-images (instagram phone images)
	$('.slider-images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 5000,
		fade: false,
		pauseOnHover: false,
		speed: 600,
		centerMode: true,
		variableWidth: true,
	});
// END of script for slider-images (instagram phone images)

// BEGIN of script for theme secondary (purple) color of landing page
	if ($('#box-page-default').length > 0) {
		if ($('#box-page-default').attr('class') != 'page-custom-class') {
			$('body').addClass($('#box-page-default').attr('class'));
			$('body').addClass('page-custom-theme-color-secondary');
		};
	}
// END of script for theme secondary (purple) color of landing page

// BEGIN of script to show app popup on btn add to cart click
	if ($('#newsletter-app-popup').length > 0) {
		$('[data-product-add-to-cart-button]').click(function(event){
			$('#newsletter-app-popup').attr('open','open')
			//   event.preventDefault();
		})
	}
// END of script to show app popup on btn add to cart click

// BEGIN of script for tabs
	$('.tabs-nav-item').click(function() {
		var _id = $(this).attr('href');
		var _targetElement = $(this).parents('.tabs-wr').find(_id);
		$('.tabs-nav-item').removeClass('active');
		$('.tabs-nav-item-wrapper').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.tabs-nav-item-wrapper').addClass('active');
		$('.tabs-item').removeClass('active');
		_targetElement.addClass('active');
		return false;
	});

	$('.btn-close-tab').click(function(){
		$(this).parents('.tabs-item').removeClass('active');
	})
	// $('.tabs-nav-item:last-child').click();
// END of script for tabs

$('.btn-team-item-details').click(function(){
	$(this).parents('.team-item-details').toggleClass('active');
});

// BEGIN of script for accordion
	$('.accordion-item-nav').click(function(){
		var _accItemParent = $(this).parents('.accordion-item');
		if (_accItemParent.hasClass('active')) {
			$('.accordion-item').removeClass('active');
			$('.accordion-item .accordion-item-content').slideUp(400,function(){
			});
		} else {
			// $('.accordion-item').removeClass('active');
			// $('.accordion-item .accordion-item-content').slideUp(400);
			_accItemParent.addClass('active');
			_accItemParent.find('.accordion-item-content').slideDown(400,function(){
			});
		}
	})
	// $('.accordion-item:first-child .accordion-item-nav a').click();
// END of script for accordion

if ($('.news-menu-wr').length>0) {
    $('.investors-menu-wr .menu-pages-news-events, .investors-menu-wr .menu-pages-press-releases').addClass('active');
};















});




// BEGIN of script for page load
window.onload = function() {

	// BEGIN of script for init wow.js for animate.css
		if(Modernizr.cssanimations) {
			wow = new WOW({
// 				mobile: false,
			});
			wow.init();
		}
	// END of script for init wow.js for animate.css

// BEGIN of script for isotope/filter
    // init Isotope
    var $grid = $('.masonry-grid .multi-column__inner').isotope({
        itemSelector: '.masonry-grid .multi-column__item',
        // layoutMode: 'masonry',
        masonry: {
            gutter: 0
        }
    });
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
        $grid.isotope('layout');
    });
// END of script for isotope/filter


if ( $('.reviews-massonry').length > 0 ) {

    const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
            // each entry is an instance of ResizeObserverEntry
            console.log(entry.contentRect.height)


                 // BEGIN of script for isotope/filter
                    // init Isotope
                    $grid2 = $('.jdgm-all-reviews__body').isotope({
                        itemSelector: '.jdgm-rev',
                        // layoutMode: 'masonry',
                        masonry: {
                            gutter: 0
                        }
                    });
                    // layout Isotope after each image loads
                    $grid2.imagesLoaded().progress( function() {
                        $grid2.isotope('layout');
                    });
                // END of script for isotope/filter



                    $grid2.isotope('reloadItems');
                    $grid2.isotope('destroy');


                 // BEGIN of script for isotope/filter
                    // init Isotope
                    $grid2 = $('.jdgm-all-reviews__body').isotope({
                        itemSelector: '.jdgm-rev',
                        // layoutMode: 'masonry',
                        masonry: {
                            gutter: 0
                        }
                    });
                    // layout Isotope after each image loads
                    $grid2.imagesLoaded().progress( function() {
                        $grid2.isotope('layout');
                    });
                // END of script for isotope/filter
        }
    })
    observer.observe(document.querySelector('body'));
}



};
// END of script for page loader




























// <script type="text/javascript">
	function chooseProduct(type) {
	  if (type == 'download') {
	    $("#instructions-app").slideUp();
	    $("#instructions-cdg").slideUp();
	    $("#instructions-formv1").slideUp();
	    $("#instructions-download").slideDown(function(){
	      goTo("instructions-download", 120);
	    });
	  }
	  else if (type == 'app') {
	    $("#instructions-download").slideUp();
	    $("#instructions-cdg").slideUp();
	    $("#instructions-formv1").slideUp();
	    $("#instructions-app").slideDown(function(){
	      goTo("instructions-app", 120);
	    });
	  }
	  else if (type == 'cdg') {
	    $("#instructions-download").slideUp();
	    $("#instructions-app").slideUp();
	    $("#instructions-formv1").slideUp();
	    $("#instructions-cdg").slideDown(function(){
	      goTo("instructions-cdg", 120);
	    });
	  }
	  else if (type == 'formv1') {
	    $("#instructions-download").slideUp();
	    $("#instructions-app").slideUp();
	    $("#instructions-cdg").slideUp();
	    $("#instructions-formv1").slideDown(function(){
	      goTo("instructions-formv1", 120);
	    });
	  }
	}
	
	$(function() {
	  $('select').select2();
	  $('.models').change(function(){
	    if ($(this).val() != '') {
	
	      var type = $(this).find(':selected').data('type');
	
	      if (typeof type == "undefined" || !type) {
	        type = 'app';
	      }
	
	      if (type == 'cdg' || type == 'download' || type == 'app' || type == 'formv1') {
	        chooseProduct(type);
	
	        if (type == 'formv1') {
	          $("#input_10").val($(this).val());  
	        }
	      }
	      else {
	        chooseProduct('app');
	      }
	
	      $(".help-section").show();
	    }
	    else {
	    }
	  });
	  $(".toggle-box").hide();
	  $(".toggle-default-open").show();
	  $(".toggle").click(function() {
	    $(this).next(".toggle-box").slideToggle();
	    if ($(this).hasClass("toggle-active")) {
	      $(this).removeClass("toggle-active");
	    }
	    else {
	      $(this).addClass("toggle-active");
	    }
	  });
	
	  $("#formv1").submit(function(){
	    event.preventDefault();
	    // Show loading screen
	    $(".ajax-loader").show();
	    submitForm();
	  });
	});
	
	function showInstructions(id) {
	  if (id == 'own-your-song-download') {
	    $("#own-your-song-download").slideDown(function(){
	      goTo(id, 120);
	    });
	    $("#stream-your-song-download").slideUp();
	  }
	  if (id == 'stream-your-song-download') {
	    $("#own-your-song-download").slideUp();
	    $("#stream-your-song-download").slideDown(function(){
	      goTo(id, 120);
	    });
	  }
	  if (id == 'own-your-song-cdg') {
	    $("#own-your-song-cdg").slideDown(function(){
	      goTo(id, 120);
	    });
	    $("#stream-your-song-cdg").slideUp();
	  }
	  if (id == 'stream-your-song-cdg') {
	    $("#own-your-song-cdg").slideUp();
	    $("#stream-your-song-cdg").slideDown(function(){
	      goTo(id, 120);
	    });
	  }
	}
	
	function goTo(id, offset) {
	  $('html, body').animate({
	    scrollTop: $("#"+id).offset().top - offset
	  }, 800);
	}
	
	function submitForm() {
	  $("#formv1-submit-btn").prop('disabled', true);
	  var posting = $.post('https://www2.singingmachine.com/shopify/form-submission.php', $("#formv1").serialize(), "json");
	
	  posting.done(function( data ) {
	    $("#formv1-submit-btn").prop('disabled', false);
	    $(".ajax-loader").hide();
	    if (data) {
	      if (data.hasOwnProperty('response') && data.response.hasOwnProperty('is_valid') && !data.response.is_valid) {
	
	        // Error
	        $(".validation-error").text("There was a problem with your submission. Errors have been highlighted below.").show();
	
	        $('.form .row').each(function(){
	          // Clear previous form errors
	          $(this).removeClass('field-error');
	          $(this).find(".error").hide();
	        });
	
	        // Go over errors
	        if (data.response.validation_messages) {
	          $.each(data.response.validation_messages, function(i, item) {
	            $("#input_" + i).closest(".row").addClass("field-error");
	            $("#input_" + i).closest(".item").find(".error").text(item).show();
	          });
	        }
	      }
	      else if (data.hasOwnProperty('response') && data.response.hasOwnProperty('is_valid') && data.response.is_valid) {
	        // Success
	        $(".validation-error").hide();
	        $('.form .row').each(function(){
	          // Clear previous form errors
	          $(this).removeClass('field-error');
	          $(this).find(".error").hide();
	        });
	
	        var confirmationObj = data.response.confirmation_message;
	        $("#instructions-formv1 .form").slideUp();
	        $("#formv1-success").slideDown();
	      }
	      else {
	        $(".validation-error").hide();
	        $('.form .row').each(function(){
	          // Clear previous form errors
	          $(this).removeClass('field-error');
	          $(this).find(".error").hide();
	        });
	
	        if (data.hasOwnProperty('response')) {
	          $(".validation-error").text(data.response).show();
	        }
	      }
	
	      goTo('instructions-formv1', 100);
	    }
	  });
	
	  posting.fail(function(xhr, status, error) {
	    $("#formv1-submit-btn").prop('disabled', false);
	    $(".ajax-loader").hide();
	    $(".validation-error").text("An error prevented from processing your request. Please try again later.").show();
	  });
	}
// </script>

















